import { useCallback } from 'react'
import { useApolloClient } from 'apollo-client'
import { GraphQLError } from 'helpers'

import paymentDataQuery, { type PaymentProfileVariables } from './paymentData.graphql'


const usePaymentData = () => {
  const apolloClient = useApolloClient()

  return useCallback(async (input: PaymentProfileVariables['input']) => {
    const result = await apolloClient.query({
      query: paymentDataQuery,
      fetchPolicy: 'no-cache',
      variables: {
        input,
      },
    })

    if (result.errors) {
      throw new GraphQLError(result.errors)
    }

    return result.data
  }, [ apolloClient ])
}


export default usePaymentData
